import { GraphQLClient, RequestOptions } from "graphql-request";
import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
type GraphQLClientRequestHeaders = RequestOptions["requestHeaders"];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Amount: { input: number; output: number };
  Any: { input: any; output: any };
  GrafferMimeType: { input: any; output: any };
  InvoiceBusinessIssuerRegistrationNumber: { input: any; output: any };
  Map: { input: any; output: any };
  Time: { input: any; output: any };
};

export type CreateInvoiceBusinessIssuerRequest = {
  groupIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  name: Scalars["String"]["input"];
  orgId: Scalars["ID"]["input"];
  registrationNumber: Scalars["InvoiceBusinessIssuerRegistrationNumber"]["input"];
};

export type CreateServiceAccountInput = {
  accountName: Scalars["String"]["input"];
  description: Scalars["String"]["input"];
  groupsRoles: Scalars["Map"]["input"];
  roles: Array<Roles>;
  tenantId: Scalars["ID"]["input"];
};

export type CreateServiceAccountKeyInput = {
  expiredAtUnixMilliSecond: Scalars["Int"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  serviceAccountId: Scalars["ID"]["input"];
  tenantId: Scalars["ID"]["input"];
};

export type CreateServiceAccountKeyOutput = {
  __typename?: "CreateServiceAccountKeyOutput";
  privateKeyPem: Scalars["String"]["output"];
  serviceAccountKey: ServiceAccountKey;
};

export type DomainError = {
  __typename?: "DomainError";
  code: DomainErrorCode;
  message: Scalars["String"]["output"];
  path: Scalars["String"]["output"];
};

export type DomainErrorCode = "bad_request" | "not_found";

export type EmptyResult = {
  __typename?: "EmptyResult";
  msg: EmptyResultMsg;
};

export type EmptyResultMsg = "OK";

export type Group = {
  __typename?: "Group";
  createdAt: Scalars["Time"]["output"];
  email: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isIgnoreAclSetting: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  orgId: Scalars["ID"]["output"];
  updatedAt: Scalars["Time"]["output"];
};

export type InvoiceBusinessIssuer = {
  __typename?: "InvoiceBusinessIssuer";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  orgId: Scalars["ID"]["output"];
  registrationNumber: Scalars["InvoiceBusinessIssuerRegistrationNumber"]["output"];
};

export type InvoiceBusinessIssuerGroupRelation = {
  __typename?: "InvoiceBusinessIssuerGroupRelation";
  groupId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  orgId: Scalars["ID"]["output"];
};

export type InvoiceBusinessIssuerWithGroups = {
  __typename?: "InvoiceBusinessIssuerWithGroups";
  groups: Array<Group>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  orgId: Scalars["ID"]["output"];
  registrationNumber: Scalars["InvoiceBusinessIssuerRegistrationNumber"]["output"];
};

export type IsNotFound = {
  __typename?: "IsNotFound";
  error: DomainError;
};

export type LegalDocument = {
  __typename?: "LegalDocument";
  content: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type Mutation = {
  __typename?: "Mutation";
  createInvoiceBusinessIssuer: Scalars["Boolean"]["output"];
  createOrgProduct: Scalars["Boolean"]["output"];
  createOrgSamlSetting: Scalars["Boolean"]["output"];
  createServiceAccount: ServiceAccount;
  createServiceAccountKey: CreateServiceAccountKeyOutput;
  disableServiceAccount: EmptyResult;
  disableServiceAccountKey: EmptyResult;
  noop: Scalars["String"]["output"];
  updateInvoiceBusinessIssuer: Scalars["Boolean"]["output"];
  updateOrgGBizIDSetting: EmptyResult;
  updateOrgProduct: Scalars["Boolean"]["output"];
  updateOrgSamlSetting: Scalars["Boolean"]["output"];
  updateServiceAccount: ServiceAccount;
};

export type MutationCreateInvoiceBusinessIssuerArgs = {
  req: CreateInvoiceBusinessIssuerRequest;
};

export type MutationCreateOrgProductArgs = {
  legalTermUrl?: InputMaybe<Scalars["String"]["input"]>;
  orgId: Scalars["String"]["input"];
  plan: Plan;
  productCode: ProductCode;
};

export type MutationCreateOrgSamlSettingArgs = {
  req: OrgSamlSettingRequest;
};

export type MutationCreateServiceAccountArgs = {
  input: CreateServiceAccountInput;
};

export type MutationCreateServiceAccountKeyArgs = {
  input: CreateServiceAccountKeyInput;
};

export type MutationDisableServiceAccountArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDisableServiceAccountKeyArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationUpdateInvoiceBusinessIssuerArgs = {
  req: UpdateInvoiceBusinessIssuerRequest;
};

export type MutationUpdateOrgGBizIdSettingArgs = {
  activated: Scalars["Boolean"]["input"];
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  orgId: Scalars["String"]["input"];
};

export type MutationUpdateOrgProductArgs = {
  legalTermUrl?: InputMaybe<Scalars["String"]["input"]>;
  orgId: Scalars["String"]["input"];
  plan: Plan;
  productCode: ProductCode;
};

export type MutationUpdateOrgSamlSettingArgs = {
  id: Scalars["ID"]["input"];
  req: OrgSamlSettingRequest;
};

export type MutationUpdateServiceAccountArgs = {
  input: UpdateServiceAccountInput;
};

export type OrgProduct = {
  __typename?: "OrgProduct";
  createdAt?: Maybe<Scalars["Time"]["output"]>;
  id: Scalars["ID"]["output"];
  legalTermUrl: Scalars["String"]["output"];
  orgId: Scalars["ID"]["output"];
  plan: Plan;
  productCode: ProductCode;
  updatedAt?: Maybe<Scalars["Time"]["output"]>;
};

export type OrgSamlSetting = {
  __typename?: "OrgSamlSetting";
  certificateFileKey: Scalars["String"]["output"];
  createdAt: Scalars["Time"]["output"];
  id: Scalars["ID"]["output"];
  idProviderEntityId: Scalars["String"]["output"];
  idProviderSsoUrl: Scalars["String"]["output"];
  orgId: Scalars["ID"]["output"];
  relayState: Scalars["String"]["output"];
  samlSlug: Scalars["String"]["output"];
  updatedAt: Scalars["Time"]["output"];
};

export type OrgSamlSettingRequest = {
  certificateFileKey: Scalars["String"]["input"];
  idProviderEntityId: Scalars["String"]["input"];
  idProviderSsoUrl: Scalars["String"]["input"];
  orgId: Scalars["ID"]["input"];
  samlSlug: Scalars["String"]["input"];
};

export type OrgUser = {
  __typename?: "OrgUser";
  accountName: Scalars["String"]["output"];
  createdAt: Scalars["Time"]["output"];
  disabled: Scalars["Boolean"]["output"];
  groupIds: Array<Scalars["ID"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  orgId: Scalars["ID"]["output"];
  requirePasswordChange: Scalars["Boolean"]["output"];
  roles: Array<Roles>;
  totp?: Maybe<Totp>;
  updatedAt: Scalars["Time"]["output"];
};

export type OrgUserCount = {
  __typename?: "OrgUserCount";
  count: Scalars["Int"]["output"];
};

export type Page = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
};

export type PageInfo = {
  __typename?: "PageInfo";
  currentPage: Scalars["Int"]["output"];
  totalPage: Scalars["Int"]["output"];
};

export type Permission =
  | "invoiceBusinessIssuers_create"
  | "invoiceBusinessIssuers_read"
  | "invoiceBusinessIssuers_update"
  | "orgSamlSettings_create"
  | "orgSamlSettings_read"
  | "orgSamlSettings_update"
  | "organizations_create"
  | "organizations_update"
  | "serviceAccount_serviceAccountKey_create"
  | "serviceAccount_serviceAccountKey_disable"
  | "serviceAccount_serviceAccount_create"
  | "serviceAccount_serviceAccount_disable"
  | "serviceAccount_serviceAccount_read"
  | "serviceAccount_serviceAccount_update"
  | "users_read";

export type Plan =
  | "Advanced"
  | "CMSOnly"
  | "Free"
  | "Light"
  | "NotSet"
  | "Package"
  | "SelfServe"
  | "Standard";

export type ProductCode =
  | "AIStudio"
  | "BoothReserve"
  | "Call"
  | "KintoneExport"
  | "MadoguchiEditor"
  | "NinteiShoukai"
  | "Portal"
  | "ServiceAccount"
  | "SmartApply"
  | "Survey"
  | "TtzkGuide";

export type Query = {
  __typename?: "Query";
  allOrgProductsByOrgId: Array<OrgProduct>;
  healthcheck: Scalars["String"]["output"];
  invoiceBusinessIssuerByGroupID?: Maybe<InvoiceBusinessIssuer>;
  invoiceBusinessIssuerByID: InvoiceBusinessIssuerWithGroups;
  invoiceBusinessIssuerGroupRelationsByOrgID: Array<InvoiceBusinessIssuerGroupRelation>;
  invoiceBusinessIssuersByOrgID: Array<InvoiceBusinessIssuerWithGroups>;
  orgProductsByOrgId: Array<OrgProduct>;
  orgSamlSetting?: Maybe<OrgSamlSetting>;
  orgSamlSettingExists: Scalars["Boolean"]["output"];
  orgUsersCountByOrgIdAndAccountNames: OrgUserCount;
  privacyPolicy: LegalDocument;
  serviceAccount: ServiceAccount;
  serviceAccounts: Array<ServiceAccount>;
  termsOfUse: LegalDocument;
};

export type QueryAllOrgProductsByOrgIdArgs = {
  orgId: Scalars["String"]["input"];
};

export type QueryInvoiceBusinessIssuerByGroupIdArgs = {
  groupId: Scalars["ID"]["input"];
  orgId: Scalars["ID"]["input"];
};

export type QueryInvoiceBusinessIssuerByIdArgs = {
  id: Scalars["ID"]["input"];
  orgId: Scalars["ID"]["input"];
};

export type QueryInvoiceBusinessIssuerGroupRelationsByOrgIdArgs = {
  orgId: Scalars["ID"]["input"];
};

export type QueryInvoiceBusinessIssuersByOrgIdArgs = {
  orgId: Scalars["ID"]["input"];
};

export type QueryOrgProductsByOrgIdArgs = {
  orgId: Scalars["String"]["input"];
};

export type QueryOrgSamlSettingArgs = {
  orgID: Scalars["ID"]["input"];
};

export type QueryOrgSamlSettingExistsArgs = {
  orgSlug: Scalars["String"]["input"];
};

export type QueryOrgUsersCountByOrgIdAndAccountNamesArgs = {
  accountNames: Array<Scalars["String"]["input"]>;
  orgId: Scalars["ID"]["input"];
};

export type QueryServiceAccountArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryServiceAccountsArgs = {
  tenantId: Scalars["ID"]["input"];
};

export type QueryTermsOfUseArgs = {
  productCode: Scalars["String"]["input"];
  slug: Scalars["String"]["input"];
};

export type Roles = "AccountManager" | "Admin" | "GrafferStaff" | "Staff";

export type ServiceAccount = {
  __typename?: "ServiceAccount";
  accountName: Scalars["String"]["output"];
  belongingGroups: Array<Group>;
  createdAt: Scalars["Time"]["output"];
  createdAtUnixSecond: Scalars["Int"]["output"];
  description: Scalars["String"]["output"];
  disabled: Scalars["Boolean"]["output"];
  groupsRoles: Scalars["Map"]["output"];
  id: Scalars["ID"]["output"];
  roles: Array<Roles>;
  serviceAccountKeys: Array<ServiceAccountKey>;
  tenantId: Scalars["ID"]["output"];
  updatedAt: Scalars["Time"]["output"];
  updatedAtUnixSecond: Scalars["Int"]["output"];
};

export type ServiceAccountKey = {
  __typename?: "ServiceAccountKey";
  createdAt: Scalars["Time"]["output"];
  createdAtUnixSecond: Scalars["Int"]["output"];
  disabled: Scalars["Boolean"]["output"];
  expiredAt: Scalars["Time"]["output"];
  expiredAtUnixMilliSecond: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  serviceAccountId: Scalars["ID"]["output"];
  tenantId: Scalars["ID"]["output"];
  updatedAt: Scalars["Time"]["output"];
  updatedAtUnixSecond: Scalars["Int"]["output"];
};

export type Totp = {
  __typename?: "TOTP";
  disabled: Scalars["Boolean"]["output"];
  enabledAt?: Maybe<Scalars["Time"]["output"]>;
  secret: Scalars["String"]["output"];
};

export type UpdateInvoiceBusinessIssuerRequest = {
  groupIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  id: Scalars["ID"]["input"];
  orgId: Scalars["ID"]["input"];
};

export type UpdateServiceAccountInput = {
  description: Scalars["String"]["input"];
  groupsRoles: Scalars["Map"]["input"];
  id: Scalars["ID"]["input"];
  roles: Array<Roles>;
};

export type UserMetaInfo = {
  __typename?: "UserMetaInfo";
  id: Scalars["ID"]["output"];
  userType: UserType;
};

export type UserType = "GrafferStaffUser" | "OrgUser" | "System";

export type ServiceAccountEntityFragment = {
  __typename?: "ServiceAccount";
  id: string;
  tenantId: string;
  groupsRoles: any;
  accountName: string;
  roles: Array<Roles>;
  disabled: boolean;
  createdAt: any;
  updatedAt: any;
  createdAtUnixSecond: number;
  updatedAtUnixSecond: number;
  description: string;
};

export type ServiceAccountKeyEntityFragment = {
  __typename?: "ServiceAccountKey";
  id: string;
  tenantId: string;
  serviceAccountId: string;
  expiredAt: any;
  expiredAtUnixMilliSecond: number;
  disabled: boolean;
  name: string;
  createdAt: any;
  updatedAt: any;
  createdAtUnixSecond: number;
  updatedAtUnixSecond: number;
};

export type CreateInvoiceBusinessIssuerMutationVariables = Exact<{
  req: CreateInvoiceBusinessIssuerRequest;
}>;

export type CreateInvoiceBusinessIssuerMutation = {
  __typename?: "Mutation";
  createInvoiceBusinessIssuer: boolean;
};

export type CreateOrgProductMutationVariables = Exact<{
  orgId: Scalars["String"]["input"];
  productCode: ProductCode;
  plan: Plan;
  legalTermUrl?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CreateOrgProductMutation = {
  __typename?: "Mutation";
  createOrgProduct: boolean;
};

export type CreateOrgSamlSettingMutationVariables = Exact<{
  req: OrgSamlSettingRequest;
}>;

export type CreateOrgSamlSettingMutation = {
  __typename?: "Mutation";
  createOrgSamlSetting: boolean;
};

export type GetInvoiceBusinessIssuerGroupRelationsByOrgIdQueryVariables =
  Exact<{
    orgId: Scalars["ID"]["input"];
  }>;

export type GetInvoiceBusinessIssuerGroupRelationsByOrgIdQuery = {
  __typename?: "Query";
  invoiceBusinessIssuerGroupRelationsByOrgID: Array<{
    __typename?: "InvoiceBusinessIssuerGroupRelation";
    groupId: string;
  }>;
};

export type GetInvoiceBusinessIssuersByOrgIdQueryVariables = Exact<{
  orgId: Scalars["ID"]["input"];
}>;

export type GetInvoiceBusinessIssuersByOrgIdQuery = {
  __typename?: "Query";
  invoiceBusinessIssuersByOrgID: Array<{
    __typename?: "InvoiceBusinessIssuerWithGroups";
    id: string;
    name: string;
    registrationNumber: any;
    groups: Array<{ __typename?: "Group"; id: string; name: string }>;
  }>;
};

export type OrgProductsQueryVariables = Exact<{
  id: Scalars["String"]["input"];
}>;

export type OrgProductsQuery = {
  __typename?: "Query";
  orgProductsByOrgId: Array<{
    __typename?: "OrgProduct";
    id: string;
    orgId: string;
    productCode: ProductCode;
    plan: Plan;
    legalTermUrl: string;
  }>;
};

export type AllOrgProductsByOrgIdQueryVariables = Exact<{
  orgId: Scalars["String"]["input"];
}>;

export type AllOrgProductsByOrgIdQuery = {
  __typename?: "Query";
  allOrgProductsByOrgId: Array<{
    __typename?: "OrgProduct";
    id: string;
    orgId: string;
    productCode: ProductCode;
    plan: Plan;
    legalTermUrl: string;
  }>;
};

export type OrgSamlSettingQueryVariables = Exact<{
  orgID: Scalars["ID"]["input"];
}>;

export type OrgSamlSettingQuery = {
  __typename?: "Query";
  orgSamlSetting?: {
    __typename?: "OrgSamlSetting";
    id: string;
    orgId: string;
    samlSlug: string;
    idProviderSsoUrl: string;
    idProviderEntityId: string;
    certificateFileKey: string;
    createdAt: any;
    updatedAt: any;
    relayState: string;
  } | null;
};

export type OrgUsersCountByOrgIdAndAccountNamesQueryVariables = Exact<{
  orgId: Scalars["ID"]["input"];
  accountNames: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type OrgUsersCountByOrgIdAndAccountNamesQuery = {
  __typename?: "Query";
  orgUsersCountByOrgIdAndAccountNames: {
    __typename?: "OrgUserCount";
    count: number;
  };
};

export type GetQualifiedInvoiceBusinessIssuerByGroupIdQueryVariables = Exact<{
  orgId: Scalars["ID"]["input"];
  groupId: Scalars["ID"]["input"];
}>;

export type GetQualifiedInvoiceBusinessIssuerByGroupIdQuery = {
  __typename?: "Query";
  invoiceBusinessIssuerByGroupID?: {
    __typename?: "InvoiceBusinessIssuer";
    id: string;
    name: string;
    registrationNumber: any;
  } | null;
};

export type GetQualifiedInvoiceBusinessIssuerByIdQueryVariables = Exact<{
  orgId: Scalars["ID"]["input"];
  id: Scalars["ID"]["input"];
}>;

export type GetQualifiedInvoiceBusinessIssuerByIdQuery = {
  __typename?: "Query";
  invoiceBusinessIssuerByID: {
    __typename?: "InvoiceBusinessIssuerWithGroups";
    id: string;
    name: string;
    registrationNumber: any;
    groups: Array<{ __typename?: "Group"; id: string; name: string }>;
  };
};

export type OrgSamlSettingExistsQueryVariables = Exact<{
  slug: Scalars["String"]["input"];
}>;

export type OrgSamlSettingExistsQuery = {
  __typename?: "Query";
  orgSamlSettingExists: boolean;
};

export type ServiceAccountsQueryVariables = Exact<{
  tenantId: Scalars["ID"]["input"];
}>;

export type ServiceAccountsQuery = {
  __typename?: "Query";
  serviceAccounts: Array<{
    __typename?: "ServiceAccount";
    id: string;
    tenantId: string;
    groupsRoles: any;
    accountName: string;
    roles: Array<Roles>;
    disabled: boolean;
    createdAt: any;
    updatedAt: any;
    createdAtUnixSecond: number;
    updatedAtUnixSecond: number;
    description: string;
  }>;
};

export type ServiceAccountQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ServiceAccountQuery = {
  __typename?: "Query";
  serviceAccount: {
    __typename?: "ServiceAccount";
    id: string;
    tenantId: string;
    groupsRoles: any;
    accountName: string;
    roles: Array<Roles>;
    disabled: boolean;
    createdAt: any;
    updatedAt: any;
    createdAtUnixSecond: number;
    updatedAtUnixSecond: number;
    description: string;
    belongingGroups: Array<{ __typename?: "Group"; id: string; name: string }>;
    serviceAccountKeys: Array<{
      __typename?: "ServiceAccountKey";
      id: string;
      tenantId: string;
      serviceAccountId: string;
      expiredAt: any;
      expiredAtUnixMilliSecond: number;
      disabled: boolean;
      name: string;
      createdAt: any;
      updatedAt: any;
      createdAtUnixSecond: number;
      updatedAtUnixSecond: number;
    }>;
  };
};

export type CreateServiceAccountMutationVariables = Exact<{
  input: CreateServiceAccountInput;
}>;

export type CreateServiceAccountMutation = {
  __typename?: "Mutation";
  createServiceAccount: {
    __typename?: "ServiceAccount";
    id: string;
    tenantId: string;
    groupsRoles: any;
    accountName: string;
    roles: Array<Roles>;
    disabled: boolean;
    createdAt: any;
    updatedAt: any;
    createdAtUnixSecond: number;
    updatedAtUnixSecond: number;
    description: string;
  };
};

export type UpdateServiceAccountMutationVariables = Exact<{
  input: UpdateServiceAccountInput;
}>;

export type UpdateServiceAccountMutation = {
  __typename?: "Mutation";
  updateServiceAccount: {
    __typename?: "ServiceAccount";
    id: string;
    tenantId: string;
    groupsRoles: any;
    accountName: string;
    roles: Array<Roles>;
    disabled: boolean;
    createdAt: any;
    updatedAt: any;
    createdAtUnixSecond: number;
    updatedAtUnixSecond: number;
    description: string;
    belongingGroups: Array<{ __typename?: "Group"; id: string; name: string }>;
  };
};

export type DisableServiceAccountMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DisableServiceAccountMutation = {
  __typename?: "Mutation";
  disableServiceAccount: { __typename?: "EmptyResult"; msg: EmptyResultMsg };
};

export type CreateServiceAccountKeyMutationVariables = Exact<{
  input: CreateServiceAccountKeyInput;
}>;

export type CreateServiceAccountKeyMutation = {
  __typename?: "Mutation";
  createServiceAccountKey: {
    __typename?: "CreateServiceAccountKeyOutput";
    privateKeyPem: string;
    serviceAccountKey: {
      __typename?: "ServiceAccountKey";
      id: string;
      tenantId: string;
      serviceAccountId: string;
      expiredAt: any;
      expiredAtUnixMilliSecond: number;
      disabled: boolean;
      name: string;
      createdAt: any;
      updatedAt: any;
      createdAtUnixSecond: number;
      updatedAtUnixSecond: number;
    };
  };
};

export type DisableServiceAccountKeyMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DisableServiceAccountKeyMutation = {
  __typename?: "Mutation";
  disableServiceAccountKey: { __typename?: "EmptyResult"; msg: EmptyResultMsg };
};

export type UpdateOrgGBizIdSettingMutationVariables = Exact<{
  orgId: Scalars["String"]["input"];
  activated: Scalars["Boolean"]["input"];
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateOrgGBizIdSettingMutation = {
  __typename?: "Mutation";
  updateOrgGBizIDSetting: { __typename?: "EmptyResult"; msg: EmptyResultMsg };
};

export type UpdateOrgProductMutationVariables = Exact<{
  orgId: Scalars["String"]["input"];
  productCode: ProductCode;
  plan: Plan;
  legalTermUrl?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateOrgProductMutation = {
  __typename?: "Mutation";
  updateOrgProduct: boolean;
};

export type UpdateOrgSamlSettingMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  req: OrgSamlSettingRequest;
}>;

export type UpdateOrgSamlSettingMutation = {
  __typename?: "Mutation";
  updateOrgSamlSetting: boolean;
};

export type UpdateQualifiedInvoiceBusinessIssuerMutationVariables = Exact<{
  req: UpdateInvoiceBusinessIssuerRequest;
}>;

export type UpdateQualifiedInvoiceBusinessIssuerMutation = {
  __typename?: "Mutation";
  updateInvoiceBusinessIssuer: boolean;
};

export const ServiceAccountEntityFragmentDoc = gql`
  fragment ServiceAccountEntity on ServiceAccount {
    id
    tenantId
    groupsRoles
    accountName
    roles
    disabled
    createdAt
    updatedAt
    createdAtUnixSecond
    updatedAtUnixSecond
    description
  }
`;
export const ServiceAccountKeyEntityFragmentDoc = gql`
  fragment ServiceAccountKeyEntity on ServiceAccountKey {
    id
    tenantId
    serviceAccountId
    expiredAt
    expiredAtUnixMilliSecond
    disabled
    name
    createdAt
    updatedAt
    createdAtUnixSecond
    updatedAtUnixSecond
  }
`;
export const CreateInvoiceBusinessIssuerDocument = gql`
  mutation createInvoiceBusinessIssuer(
    $req: CreateInvoiceBusinessIssuerRequest!
  ) {
    createInvoiceBusinessIssuer(req: $req)
  }
`;
export const CreateOrgProductDocument = gql`
  mutation CreateOrgProduct(
    $orgId: String!
    $productCode: ProductCode!
    $plan: Plan!
    $legalTermUrl: String
  ) {
    createOrgProduct(
      orgId: $orgId
      productCode: $productCode
      plan: $plan
      legalTermUrl: $legalTermUrl
    )
  }
`;
export const CreateOrgSamlSettingDocument = gql`
  mutation createOrgSamlSetting($req: OrgSamlSettingRequest!) {
    createOrgSamlSetting(req: $req)
  }
`;
export const GetInvoiceBusinessIssuerGroupRelationsByOrgIdDocument = gql`
  query getInvoiceBusinessIssuerGroupRelationsByOrgId($orgId: ID!) {
    invoiceBusinessIssuerGroupRelationsByOrgID(orgId: $orgId) {
      groupId
    }
  }
`;
export const GetInvoiceBusinessIssuersByOrgIdDocument = gql`
  query getInvoiceBusinessIssuersByOrgId($orgId: ID!) {
    invoiceBusinessIssuersByOrgID(orgId: $orgId) {
      id
      name
      registrationNumber
      groups {
        id
        name
      }
    }
  }
`;
export const OrgProductsDocument = gql`
  query orgProducts($id: String!) {
    orgProductsByOrgId(orgId: $id) {
      id
      orgId
      productCode
      plan
      legalTermUrl
    }
  }
`;
export const AllOrgProductsByOrgIdDocument = gql`
  query allOrgProductsByOrgId($orgId: String!) {
    allOrgProductsByOrgId(orgId: $orgId) {
      id
      orgId
      productCode
      plan
      legalTermUrl
    }
  }
`;
export const OrgSamlSettingDocument = gql`
  query orgSamlSetting($orgID: ID!) {
    orgSamlSetting(orgID: $orgID) {
      id
      orgId
      samlSlug
      idProviderSsoUrl
      idProviderEntityId
      certificateFileKey
      createdAt
      updatedAt
      relayState
    }
  }
`;
export const OrgUsersCountByOrgIdAndAccountNamesDocument = gql`
  query orgUsersCountByOrgIdAndAccountNames(
    $orgId: ID!
    $accountNames: [String!]!
  ) {
    orgUsersCountByOrgIdAndAccountNames(
      orgId: $orgId
      accountNames: $accountNames
    ) {
      count
    }
  }
`;
export const GetQualifiedInvoiceBusinessIssuerByGroupIdDocument = gql`
  query getQualifiedInvoiceBusinessIssuerByGroupID($orgId: ID!, $groupId: ID!) {
    invoiceBusinessIssuerByGroupID(orgId: $orgId, groupId: $groupId) {
      id
      name
      registrationNumber
    }
  }
`;
export const GetQualifiedInvoiceBusinessIssuerByIdDocument = gql`
  query getQualifiedInvoiceBusinessIssuerByID($orgId: ID!, $id: ID!) {
    invoiceBusinessIssuerByID(orgId: $orgId, id: $id) {
      id
      name
      registrationNumber
      groups {
        id
        name
      }
    }
  }
`;
export const OrgSamlSettingExistsDocument = gql`
  query orgSamlSettingExists($slug: String!) {
    orgSamlSettingExists(orgSlug: $slug)
  }
`;
export const ServiceAccountsDocument = gql`
  query serviceAccounts($tenantId: ID!) {
    serviceAccounts(tenantId: $tenantId) {
      ...ServiceAccountEntity
    }
  }
  ${ServiceAccountEntityFragmentDoc}
`;
export const ServiceAccountDocument = gql`
  query serviceAccount($id: ID!) {
    serviceAccount(id: $id) {
      ...ServiceAccountEntity
      belongingGroups {
        id
        name
      }
      serviceAccountKeys {
        ...ServiceAccountKeyEntity
      }
    }
  }
  ${ServiceAccountEntityFragmentDoc}
  ${ServiceAccountKeyEntityFragmentDoc}
`;
export const CreateServiceAccountDocument = gql`
  mutation createServiceAccount($input: CreateServiceAccountInput!) {
    createServiceAccount(input: $input) {
      ...ServiceAccountEntity
    }
  }
  ${ServiceAccountEntityFragmentDoc}
`;
export const UpdateServiceAccountDocument = gql`
  mutation updateServiceAccount($input: UpdateServiceAccountInput!) {
    updateServiceAccount(input: $input) {
      ...ServiceAccountEntity
      belongingGroups {
        id
        name
      }
    }
  }
  ${ServiceAccountEntityFragmentDoc}
`;
export const DisableServiceAccountDocument = gql`
  mutation disableServiceAccount($id: ID!) {
    disableServiceAccount(id: $id) {
      msg
    }
  }
`;
export const CreateServiceAccountKeyDocument = gql`
  mutation createServiceAccountKey($input: CreateServiceAccountKeyInput!) {
    createServiceAccountKey(input: $input) {
      serviceAccountKey {
        ...ServiceAccountKeyEntity
      }
      privateKeyPem
    }
  }
  ${ServiceAccountKeyEntityFragmentDoc}
`;
export const DisableServiceAccountKeyDocument = gql`
  mutation disableServiceAccountKey($id: ID!) {
    disableServiceAccountKey(id: $id) {
      msg
    }
  }
`;
export const UpdateOrgGBizIdSettingDocument = gql`
  mutation UpdateOrgGBizIDSetting(
    $orgId: String!
    $activated: Boolean!
    $clientId: String
    $clientSecret: String
  ) {
    updateOrgGBizIDSetting(
      orgId: $orgId
      activated: $activated
      clientId: $clientId
      clientSecret: $clientSecret
    ) {
      msg
    }
  }
`;
export const UpdateOrgProductDocument = gql`
  mutation UpdateOrgProduct(
    $orgId: String!
    $productCode: ProductCode!
    $plan: Plan!
    $legalTermUrl: String
  ) {
    updateOrgProduct(
      orgId: $orgId
      productCode: $productCode
      plan: $plan
      legalTermUrl: $legalTermUrl
    )
  }
`;
export const UpdateOrgSamlSettingDocument = gql`
  mutation updateOrgSamlSetting($id: ID!, $req: OrgSamlSettingRequest!) {
    updateOrgSamlSetting(id: $id, req: $req)
  }
`;
export const UpdateQualifiedInvoiceBusinessIssuerDocument = gql`
  mutation updateQualifiedInvoiceBusinessIssuer(
    $req: UpdateInvoiceBusinessIssuerRequest!
  ) {
    updateInvoiceBusinessIssuer(req: $req)
  }
`;

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
  operationType?: string,
  variables?: any,
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (
  action,
  _operationName,
  _operationType,
  _variables,
) => action();

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper,
) {
  return {
    createInvoiceBusinessIssuer(
      variables: CreateInvoiceBusinessIssuerMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CreateInvoiceBusinessIssuerMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateInvoiceBusinessIssuerMutation>({
            document: CreateInvoiceBusinessIssuerDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "createInvoiceBusinessIssuer",
        "mutation",
        variables,
      );
    },
    CreateOrgProduct(
      variables: CreateOrgProductMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CreateOrgProductMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateOrgProductMutation>({
            document: CreateOrgProductDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "CreateOrgProduct",
        "mutation",
        variables,
      );
    },
    createOrgSamlSetting(
      variables: CreateOrgSamlSettingMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CreateOrgSamlSettingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateOrgSamlSettingMutation>({
            document: CreateOrgSamlSettingDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "createOrgSamlSetting",
        "mutation",
        variables,
      );
    },
    getInvoiceBusinessIssuerGroupRelationsByOrgId(
      variables: GetInvoiceBusinessIssuerGroupRelationsByOrgIdQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetInvoiceBusinessIssuerGroupRelationsByOrgIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetInvoiceBusinessIssuerGroupRelationsByOrgIdQuery>({
            document: GetInvoiceBusinessIssuerGroupRelationsByOrgIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getInvoiceBusinessIssuerGroupRelationsByOrgId",
        "query",
        variables,
      );
    },
    getInvoiceBusinessIssuersByOrgId(
      variables: GetInvoiceBusinessIssuersByOrgIdQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetInvoiceBusinessIssuersByOrgIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetInvoiceBusinessIssuersByOrgIdQuery>({
            document: GetInvoiceBusinessIssuersByOrgIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getInvoiceBusinessIssuersByOrgId",
        "query",
        variables,
      );
    },
    orgProducts(
      variables: OrgProductsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<OrgProductsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OrgProductsQuery>({
            document: OrgProductsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "orgProducts",
        "query",
        variables,
      );
    },
    allOrgProductsByOrgId(
      variables: AllOrgProductsByOrgIdQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<AllOrgProductsByOrgIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AllOrgProductsByOrgIdQuery>({
            document: AllOrgProductsByOrgIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "allOrgProductsByOrgId",
        "query",
        variables,
      );
    },
    orgSamlSetting(
      variables: OrgSamlSettingQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<OrgSamlSettingQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OrgSamlSettingQuery>({
            document: OrgSamlSettingDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "orgSamlSetting",
        "query",
        variables,
      );
    },
    orgUsersCountByOrgIdAndAccountNames(
      variables: OrgUsersCountByOrgIdAndAccountNamesQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<OrgUsersCountByOrgIdAndAccountNamesQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OrgUsersCountByOrgIdAndAccountNamesQuery>({
            document: OrgUsersCountByOrgIdAndAccountNamesDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "orgUsersCountByOrgIdAndAccountNames",
        "query",
        variables,
      );
    },
    getQualifiedInvoiceBusinessIssuerByGroupID(
      variables: GetQualifiedInvoiceBusinessIssuerByGroupIdQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetQualifiedInvoiceBusinessIssuerByGroupIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetQualifiedInvoiceBusinessIssuerByGroupIdQuery>({
            document: GetQualifiedInvoiceBusinessIssuerByGroupIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getQualifiedInvoiceBusinessIssuerByGroupID",
        "query",
        variables,
      );
    },
    getQualifiedInvoiceBusinessIssuerByID(
      variables: GetQualifiedInvoiceBusinessIssuerByIdQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<GetQualifiedInvoiceBusinessIssuerByIdQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<GetQualifiedInvoiceBusinessIssuerByIdQuery>({
            document: GetQualifiedInvoiceBusinessIssuerByIdDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "getQualifiedInvoiceBusinessIssuerByID",
        "query",
        variables,
      );
    },
    orgSamlSettingExists(
      variables: OrgSamlSettingExistsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<OrgSamlSettingExistsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<OrgSamlSettingExistsQuery>({
            document: OrgSamlSettingExistsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "orgSamlSettingExists",
        "query",
        variables,
      );
    },
    serviceAccounts(
      variables: ServiceAccountsQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ServiceAccountsQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ServiceAccountsQuery>({
            document: ServiceAccountsDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "serviceAccounts",
        "query",
        variables,
      );
    },
    serviceAccount(
      variables: ServiceAccountQueryVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<ServiceAccountQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<ServiceAccountQuery>({
            document: ServiceAccountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "serviceAccount",
        "query",
        variables,
      );
    },
    createServiceAccount(
      variables: CreateServiceAccountMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CreateServiceAccountMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateServiceAccountMutation>({
            document: CreateServiceAccountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "createServiceAccount",
        "mutation",
        variables,
      );
    },
    updateServiceAccount(
      variables: UpdateServiceAccountMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UpdateServiceAccountMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateServiceAccountMutation>({
            document: UpdateServiceAccountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updateServiceAccount",
        "mutation",
        variables,
      );
    },
    disableServiceAccount(
      variables: DisableServiceAccountMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<DisableServiceAccountMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DisableServiceAccountMutation>({
            document: DisableServiceAccountDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "disableServiceAccount",
        "mutation",
        variables,
      );
    },
    createServiceAccountKey(
      variables: CreateServiceAccountKeyMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<CreateServiceAccountKeyMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<CreateServiceAccountKeyMutation>({
            document: CreateServiceAccountKeyDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "createServiceAccountKey",
        "mutation",
        variables,
      );
    },
    disableServiceAccountKey(
      variables: DisableServiceAccountKeyMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<DisableServiceAccountKeyMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<DisableServiceAccountKeyMutation>({
            document: DisableServiceAccountKeyDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "disableServiceAccountKey",
        "mutation",
        variables,
      );
    },
    UpdateOrgGBizIDSetting(
      variables: UpdateOrgGBizIdSettingMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UpdateOrgGBizIdSettingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateOrgGBizIdSettingMutation>({
            document: UpdateOrgGBizIdSettingDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UpdateOrgGBizIDSetting",
        "mutation",
        variables,
      );
    },
    UpdateOrgProduct(
      variables: UpdateOrgProductMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UpdateOrgProductMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateOrgProductMutation>({
            document: UpdateOrgProductDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "UpdateOrgProduct",
        "mutation",
        variables,
      );
    },
    updateOrgSamlSetting(
      variables: UpdateOrgSamlSettingMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UpdateOrgSamlSettingMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateOrgSamlSettingMutation>({
            document: UpdateOrgSamlSettingDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updateOrgSamlSetting",
        "mutation",
        variables,
      );
    },
    updateQualifiedInvoiceBusinessIssuer(
      variables: UpdateQualifiedInvoiceBusinessIssuerMutationVariables,
      requestHeaders?: GraphQLClientRequestHeaders,
      signal?: RequestInit["signal"],
    ): Promise<UpdateQualifiedInvoiceBusinessIssuerMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UpdateQualifiedInvoiceBusinessIssuerMutation>({
            document: UpdateQualifiedInvoiceBusinessIssuerDocument,
            variables,
            requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders },
            signal,
          }),
        "updateQualifiedInvoiceBusinessIssuer",
        "mutation",
        variables,
      );
    },
  };
}
export type Sdk = ReturnType<typeof getSdk>;
